import React, { useState } from 'react';

import { ResponseError } from '../../../common/spdCore/autogenerated/spdApiClient';
import ConfirmationButton from '../../../app/components/ConfirmationButton';
import ValidationAlert from '../../../app/components/ValidationAlert';
import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { responseErrors } from '../../../common/spdCore/validation/responseErrors';

export const CancelSynevoOrderLink = (props: {
  synevoId: string;
  sentOrderId: string;
  setRefresh?: () => void | undefined;
}) => {
  const spd = useSpdCore();
  const [saveErrors, setSaveErrors] = useState<string[]>([]);
  const [showSaveErrors, setShowSaveErrors] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleOnDelete = async () => {
    if (props.sentOrderId) {
      setIsLoading(true);
      try {
        await spd.synevo.cancelOrder(props.synevoId, props.sentOrderId);
        if (props.setRefresh) {
          props.setRefresh();
        }
      } catch (error) {
        const errors = await responseErrors(error as ResponseError);
        setSaveErrors(errors);
        setShowSaveErrors(true);
      } finally {
        setIsLoading(false);
      }
    }
  };

  return (
    <div>
      <ValidationAlert
        show={showSaveErrors}
        errors={saveErrors}
        onHide={() => setShowSaveErrors(false)}
      />
      <ConfirmationButton
        className="ms-1"
        confirmation={`Czy na pewno odwołać zlecenie w Synevo: ${
          props.sentOrderId || ''
        } ?`}
        variant="outline-danger"
        isLoading={isLoading}
        onOK={handleOnDelete}
      >
        Odwołaj
      </ConfirmationButton>
    </div>
  );
};
